// extracted by mini-css-extract-plugin
module.exports = {"container":"_5a28450529--container--H2uf4","container-tablet":"_5a28450529--container-tablet--NjhVr"};